import React, { useEffect, useState } from "react";
import { Box, Modal, IconButton, SxProps } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ImageUpload from "./UploadImage/ImageUpload";
import SelectImageUploadType from "./UploadImage/SelectImageUploadType";
import ManualImageUploadType from "./UploadImage/ManualImageUploadType";
import PreDataSetImageUpload from "./UploadImage/PreDataSetImageUpload";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../../store/store";
import { closeModal } from "../../store/slice/UISlice";
import {
  UPLOAD_MODAL,
  TYPE_UPLOAD_MODAL,
  VIEW_DETAILS_MODAL,
  UPLOAD_VIDEO_MODAL,
  MANUAL_UPLOAD_MODAL,
  PREDATASET_UPLOAD_MODAL,
} from "../../constants";
import { useDeviceSize } from "../../hooks";
import { DESKTOP_4K_SIZE_SCREEN, TABLET_SIZE_SCREEN } from "../../constants";
import ViewDetailsModal from "./ViewDetails";
import { useNavigate } from "react-router-dom";
import VideoUpload from "./UploadImage/VideoUpload";
import { fetchImagesNew } from "../../store/slice/ProjectImagesUploadedSlice";
import { useParams } from "react-router-dom";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
  overflow: "scroll",
  // maxHeight: "calc(100vh - 157px)", // command by siva beacuse in the home page view details have the auto scroll while remove this height please take care of homme page as well.
};

const closeButtonStyle: SxProps = {
  position: "absolute",
  top: 8,
  right: 8,
  zIndex: 999,
  // overflow: "scroll",
};

/**
 *
 * Reusable component to generate Modal
 *
 */
const VisionStudioModal: React.FC = () => {
  const deviceSize = useDeviceSize();
  const dispatch: AppDispatch = useDispatch();
  const { name, project, isOpen, videoFile, taskType } = useSelector(
    (state: RootState) => state.UIReducer.modalOpen
  );

  interface Params extends Record<string, string | undefined> {
    id: string; // 'id' is expected to be a string
  }

  const { id } = useParams<Params>();
  const navigate = useNavigate();
  const [closing, setClosing] = useState<Boolean>(false);

  const { images } = useSelector(
    (state: RootState) => state.ProjectImagesUploaded
  );

  const onClose = async () => {
    dispatch(closeModal());
    if (images.length === 0 && id) {
      await dispatch(
        fetchImagesNew({
          projectId: id,
          page: 1,
          count: 40,
          annotation: "all",
        })
      )
        .unwrap()
        .then((response) => {
          if (response.imageUrlModel.length === 0) {
            navigate("/projects");
          }
        });
    }
    setClosing(false);
    localStorage.setItem("popupOpen", false.toString());
  };

  return (
    <Modal
      open={isOpen}
      // onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={style}
        width={
          deviceSize === DESKTOP_4K_SIZE_SCREEN
            ? "50%"
            : deviceSize === TABLET_SIZE_SCREEN
            ? "70%"
            : "80%"
        }
      >
        <IconButton
          aria-label="close"
          onClick={() => onClose()}
          sx={closeButtonStyle}
        >
          <CloseIcon />
        </IconButton>
        {name === TYPE_UPLOAD_MODAL && (
          <SelectImageUploadType
            onClose={onClose}
            taskType={taskType}
            isImageUploader={true}
            isAnnotate={true}
          />
        )}
        {name === PREDATASET_UPLOAD_MODAL && (
          <PreDataSetImageUpload onClose={onClose} taskType={taskType} />
        )}
        {name === MANUAL_UPLOAD_MODAL && (
          <ManualImageUploadType onClose={onClose} taskType={taskType} />
        )}
        {name === UPLOAD_MODAL && <ImageUpload onClose={onClose} />}
        {name === VIEW_DETAILS_MODAL && <ViewDetailsModal project={project} />}
        {name === UPLOAD_VIDEO_MODAL && (
          <VideoUpload video={videoFile} onClose={onClose} />
        )}
        {/* need to add on close later */}
      </Box>
    </Modal>
  );
};

export default VisionStudioModal;
